import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Icon } from './components'
import { useTranslation } from 'react-i18next';
import { Tabs as BootstrapTabs, Tab } from 'react-bootstrap';
import {useHistoryState} from "./utils";

export default function Tabs(props) {
	const { t } = useTranslation();
  const [children, setChildren] = useState([])
	const [availableKeys, setAvailableKeys] = useState(getAvailableKeys())
  const [activeKey, setActiveKey] = useState(getActiveKeyFromAvailable());

  const onSelect = (k) => {
    setActiveKey(k)
    props.onChange && props.onChange(k)
  }

  function getAvailableKeys() {
    return children.map(child => {
      const { as, hide } = child.props
      if (!hide) {
        return as
      }
    })
  }

  useEffect(() => {
    setAvailableKeys(getAvailableKeys())
  }, [children])

  useEffect(() => {
    setChildren(React.Children.toArray(props.children).filter(Boolean))
  }, [props.children])

  function getActiveKeyFromAvailable() {
    if (availableKeys.includes(props.active)) {
      return props.active
    } else {
      return availableKeys[0]
    }
  }

  useEffect(() => {
    setActiveKey(getActiveKeyFromAvailable())
  }, [props.active])

	return (
		<BootstrapTabs
      activeKey={activeKey}
      onSelect={onSelect}
      className={children.filter(x => !x.props.hide !== false).length <= 1 ? "d-none" : ''}
    >
			{children.map((child) => {
				const { as, icon, hide, ...childProps } = child.props
				if (!hide) {
					const filteredChild = { ...child, props: childProps }
					return (<Tab key={as} eventKey={as} title={<Icon icon={icon} text={t(`${as}.tabName`)} />} >
				    {React.cloneElement(filteredChild)}
				  </Tab>)
				} else {
					return null
				}
			})}
		</BootstrapTabs>
	)
}

Tabs.propTypes = {
	active: PropTypes.string,
	children: PropTypes.arrayOf(PropTypes.oneOfType([
		PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    )]
	)).isRequired,
	hide: PropTypes.bool,
  tabName: PropTypes.string,
  onChange: PropTypes.func
}

export function useControlledTabs(defaultActiveTab, props = {}) {
  const currentActiveTab = useHistoryState(props, "activeTab")
  const [activeTab, setActiveTab] = useState(getTab())
  const [tabsProps, setTabsProps] = useState({onChange: setActiveTab, active: activeTab})

  function getTab() {
    return currentActiveTab || defaultActiveTab
  }

  useEffect(() => {
    setTabsProps({
      ...tabsProps,
      active: activeTab
    })
  }, [activeTab])

  useEffect(() => {
    setActiveTab(getTab())
  }, [currentActiveTab])

  return [tabsProps, setActiveTab]
}
